import { ReduxService } from 'dashboard-services/services';

import { searchCustomInsightActions } from 'actions/modules/insight';

export const searchCustomReducer = (state , action) => {
  switch (action.type) {
    case searchCustomInsightActions.ON_CHANGE_BASKET: {
      if(state.basket?.[action.basketId]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { 
          basket: ReduxService.updateObject(state.basket, {
            [action.basketId]: ReduxService.updateObject(state.basket[action.basketId] || {}, {
              [action.name]: action.value
            })
          }) 
        })
      }
      return state;
    }
    case searchCustomInsightActions.ADD_TO_BASKET: {
      return ReduxService.updateObject(state, { 
        basket: ReduxService.updateObject(state.basket, {
          [action.basketId]: ReduxService.updateObject(state.basket[action.basketId] || {}, {
            items: (state.basket[action.basketId].items || []).add(action.item)
          })
        }) 
      })
    }
    case searchCustomInsightActions.REMOVE_FROM_BASKET: {
      return ReduxService.updateObject(state, { 
        basket: ReduxService.updateObject(state.basket, {
          [action.basketId]: ReduxService.updateObject(state.basket[action.basketId] || {}, {
            items: (state.basket[action.basketId].items || []).remove(action.itemIndex)
          })
        }) 
      })
    }
    case searchCustomInsightActions.SWAP_ITEM_IN_BASKET: {
      return ReduxService.updateObject(state, { 
        basket: ReduxService.updateObject(state.basket, {
          [action.basketId]: ReduxService.updateObject(state.basket[action.basketId] || {}, {
            items: action.itemIndex === -1
              ? (state.basket[action.basketId]?.items || []).add(action.item)
              : (state.basket[action.basketId]?.items || []).remove(action.itemIndex)
          })
        }) 
      })
    }
    case searchCustomInsightActions.ON_REORDER_ITEM_IN_BASKET: {
      return ReduxService.updateObject(state, { 
        basket: ReduxService.updateObject(state.basket, {
          [action.basketId]: ReduxService.updateObject(state.basket[action.basketId] || {}, {
            items: (state.basket[action.basketId]?.items || []).moveItem(action.from, action.to)
          })
        }) 
      })
    }
    default:
      return undefined;
  }
}
